import KeenSlider from "keen-slider"

export default class {
  constructor(el) {
    const containerEl = el.querySelector(".js-sliderContainer")
    const navButtonEls = Array.from(el.querySelectorAll(".js-sliderButton"))
    const items = Array.from(containerEl?.children)

    const sizeMatch = window.matchMedia("(min-width: 800px)")

    const loopActive = items.length > 1

    function updateSlider(sldr, first = false) {
      let activeSlideIndex = sldr?.track?.details?.rel ?? 0

      items.forEach((item, index) => {
        item.classList.toggle("is-active", index === activeSlideIndex)

        const videoEl = items[index].querySelector("video")

        if (videoEl) {
          if (index === activeSlideIndex) {
            videoEl.play()
          } else {
            videoEl.pause()
          }
        }
      })

      if (!loopActive) {
        navButtonEls.forEach((buttonEl, buttonIndex) => {
          buttonEl.classList.toggle(
            "is-hidden",
            (buttonIndex === 0 && activeSlideIndex === 0) ||
              (buttonIndex === 1 && activeSlideIndex === items.length - 1),
          )
        })
      }
    }

    function onCreated(sldr) {
      updateSlider(sldr, true)
    }

    function onChangeSlide(sldr) {
      updateSlider(sldr, false)
    }

    const slider = new KeenSlider(containerEl, {
      initial: 0,
      loop: loopActive,
      rtl: false,
      rubberband: false,
      mode: "snap",
      created: onCreated,
      slideChanged: onChangeSlide,
      renderMode: "performance",
      defaultAnimation: {
        duration: 600,
        easing: (time) => {
          return 1 - Math.pow(1 - time, 4)
        },
      },
      selector: ".js-sliderItem",
      slides: {
        origin: "center",
        number: items.length,
        perView: "auto",
        spacing: () => {
          return sizeMatch.matches ? 16 * 4 : 16
        },
      },
    })

    sizeMatch.onchange = () => {
      slider.update()
    }

    if (items.length > 1) {
      if (navButtonEls) {
        navButtonEls.forEach((buttonEl, index) => {
          buttonEl.addEventListener("click", () => {
            if (index === 0) {
              slider.prev()
            } else {
              if (slider.options.loop) {
                slider.next()
              } else {
                if (slider?.track?.details?.rel == items.length - 1) {
                  slider.moveToIdx(0)
                } else {
                  slider.next()
                }
              }
            }
          })
        })
      }
    }
  }
}
